<template>
  <div
    class="content"
    style="padding: 2rem;"    
  >
    <h1>Successfully signed out. You are getting redirected.</h1>
  </div>
</template>

<script>
import um from '@/common/oidc'

export default {
  mounted() {
    um.signoutPopupCallback(false)
  }
}
</script>